export const getUnpaginatedAll = async (reqFn, page = 1, take = 50) => {
  const { data } = await reqFn({ page, take })
  if ((data.data?.length || 0) < take) {
    return data.data
  }
  return [...data.data, ...(await getUnpaginatedAll(reqFn, page + 1, take))]
}
